import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import { IconTrash } from '../../IconSet';
import { WithAuthorization } from '../../../authorization';

import { kickUser } from '../../../lib/actions/room';
import { defineMessages } from 'react-intl';
import { State } from '../../../lib/reducers';
import { isKickEnabled, isPipEnabled, canChangeRole, canFullscreen } from '../../../lib/reduxSelectors/user';
import { iconColors as colors } from '../../../colors';


const messages = defineMessages({
  ejectMessage: { id: 'ejectIconButtonTooltip' }
});



function KickMenuItem(props: ExtendedProps) {
  const { kickEnabled, user, onClose, iconSize = 20, shouldShowDivider } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const onKickUser = React.useCallback(
    () => {
      if (user) {
        const who = user.replace(/_screen$/, '');
        dispatch(kickUser(who));
      }
      onClose();
    }
    , [dispatch, user, onClose]
  );

  if (!kickEnabled) {
    return null;
  }

  return (
    <React.Fragment>
      { shouldShowDivider && <Divider /> }
      <MenuItem onClick={onKickUser} >
        <ListItemIcon>
          <IconTrash color={colors.attention} size={iconSize} />
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.ejectMessage)} />
      </MenuItem>
    </React.Fragment>
  );

}

type Props = {
  user: string;
  iconSize?: number;
  onClose: () => void;
}

type MappedProps = {
  kickEnabled: boolean;
  shouldShowDivider: boolean;
}

type ExtendedProps = Props & MappedProps;


const mapStateToProps = (state: State, props: Props): MappedProps => {
  const userId = props.user.replace(/_screen$/, '');
  return {
    kickEnabled: isKickEnabled(userId, state),
    shouldShowDivider:
      isPipEnabled(props.user, state) || canChangeRole(userId, state) || canFullscreen(props.user, state)
  };
};

const roles = ['room_owner', 'room_moderator'];

export default WithAuthorization(roles, connect(mapStateToProps)(KickMenuItem));
